// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1fZC8","inputWrap":"CustomTip_inputWrap__1Tskh"};